import createIcon from "../create-icon";

export const ChevronRightIcon = createIcon("ChevronRight", [
  ["polyline", { points: "9 18 15 12 9 6", key: "1rtp27" }],
]);
